import { render, staticRenderFns } from "./TryFrameworkContent.vue?vue&type=template&id=07e2db3a&scoped=true&"
import script from "./TryFrameworkContent.vue?vue&type=script&lang=js&"
export * from "./TryFrameworkContent.vue?vue&type=script&lang=js&"
import style0 from "./TryFrameworkContent.vue?vue&type=style&index=0&id=07e2db3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e2db3a",
  null
  
)

export default component.exports